import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../Buttons/Button";

import usersService from "../../../../../services/userService";

function StudentHeaderNavMobile({ userInfo }) {
  const { t } = useTranslation();
  return (
    <nav>
      <ul>
        <li>
          {userInfo?.avatar_url ? (
            <img
              className="userAvatar"
              src={userInfo?.avatar_url}
              alt={userInfo?.name}
            />
          ) : (
            <div className="userAvatar hasIcon--user"></div>
          )}
        </li>
        <li>
          <Button
            label={t("dashboard")}
            iconClassName="hasIcon--grid"
            viewType="noBorder"
            onClick={() => usersService.goToMonolith("dashboard/")}
          />
        </li>
        <li>
          <Button
            label={t("editProfile")}
            iconClassName="hasIcon--edit"
            viewType="noBorder"
            onClick={() =>
              usersService.goToMonolith(`accounts/readers/${userInfo?.id}/`)
            }
          />
        </li>
        <li>
          <Button
            label={t("notifications")}
            iconClassName="hasIcon--mail"
            viewType="noBorder"
            onClick={() => usersService.goToMonolith("notifications/all/")}
          />
          {userInfo?.notifications?.count > 0 && (
            <div className="menu-counter">{userInfo?.notifications?.count}</div>
          )}
        </li>
      </ul>
      <Button
        label={t("goToParent")}
        iconClassName="hasIcon--log-out"
        viewType="noBorder"
        customClassName="goToParentCustom"
        onClick={() => usersService.goToMonolith("hijack/release-hijack/")}
      />
    </nav>
  );
}

export default StudentHeaderNavMobile;
